var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddProducticon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_1734_1748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 0C5.36766 0 0 5.36705 0 12C0 18.6323 5.36705 24 12 24C18.6323 24 24 18.633 24 12C24 5.36766 18.633 0 12 0ZM12 22.4C6.26545 22.4 1.59998 17.7346 1.59998 12C1.59998 6.26541 6.26545 1.59998 12 1.59998C17.7345 1.59998 22.4 6.26545 22.4 12C22.4 17.7345 17.7345 22.4 12 22.4Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4068 11.1998H12.8V6.59298C12.8 6.15119 12.4419 5.79297 12 5.79297C11.5582 5.79297 11.2 6.15114 11.2 6.59298V11.1998H6.59323C6.15143 11.1998 5.79321 11.5579 5.79321 11.9998C5.79321 12.4416 6.15138 12.7998 6.59323 12.7998H11.2V17.4066C11.2 17.8484 11.5582 18.2066 12 18.2066C12.4419 18.2066 12.8 17.8484 12.8 17.4066V12.7998H17.4068C17.8486 12.7998 18.2068 12.4416 18.2068 11.9998C18.2068 11.5579 17.8486 11.1998 17.4068 11.1998Z",
    fill: "currentColor"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1734_1748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProducticon);
export default __webpack_public_path__ + "static/media/add-producticon.a404d7470a5da8cf39e24b5dd8bbd0df.svg";
export { ForwardRef as ReactComponent };